/**
 * Sections too slow for the first paint render a placeholder carrying
 * a `data-lazy-snippet-url` attribute and load themselves right after
 * the page is shown by requesting the component signal over ajax.
 * A placeholder may carry `<template data-lazy-snippet-failure>` shown when the request fails.
 */
const requestedUrls = new Set<string>();

export function loadLazySnippets(snippet: HTMLElement, naja: any): void {
    snippet.querySelectorAll<HTMLElement>('[data-lazy-snippet-url]:not([data-lazy-snippet-requested])').forEach(element => {
        const url = element.getAttribute('data-lazy-snippet-url');

        if (url === null || ! naja.uiHandler.isUrlAllowed(url)) {
            return;
        }

        element.setAttribute('data-lazy-snippet-requested', 'true');

        // several placeholders may share one signal that loads them all at once
        if (requestedUrls.has(url)) {
            return;
        }

        requestedUrls.add(url);

        // once the request is over the url may be requested again — a placeholder
        // re-rendered by another ajax redraw (e.g. a changed filter) loads itself anew;
        // naja 1.x returns a qwest promise, which has then and catch but no finally
        const release = (): void => {
            requestedUrls.delete(url);
        };
        // a failed request would leave the placeholder loading for ever; one with a failure template shows it instead
        const fail = (): void => {
            release();
            document.querySelectorAll<HTMLElement>('[data-lazy-snippet-requested]').forEach(placeholder => {
                const failure = placeholder.querySelector<HTMLTemplateElement>('template[data-lazy-snippet-failure]');

                if (placeholder.getAttribute('data-lazy-snippet-url') === url && failure !== null) {
                    placeholder.replaceWith(failure.content.cloneNode(true));
                }
            });
        };
        naja.makeRequest('GET', url, null, {history: false, unique: false}).then(release, fail);
    });
}
